// extracted by mini-css-extract-plugin
export default {"label":"FilterStatus_label__EgrKB"};